import client from '../../../client'

export default {
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/MasterWIRKNUpdate/MasterWIRKNUpdateFirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  Update: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/Account/AdminUserUpdate'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        irnm: param.irnm,
        irkn: param.irkn,
        egnm: param.egnm,
        kzip1: param.kzip1,
        kzip2: param.kzip2,
        kad1: param.kad1,
        kad2: param.kad2,
        ktel: param.ktel,
        fzip1: param.fzip1,
        fzip2: param.fzip2,
        fad1: param.fad1,
        fad2: param.fad2,
        ftel: param.ftel,
        uktk: param.uktk,
        nwkb: param.nwkb,
        clnd: param.clnd,
        chdy: param.chdy,
        stdy: param.stdy,
        eddy: param.eddy,
        pass: param.pass,
        //hmpg: param.hmpg,
        hmpgFileName: param.hmpgFileName,
        hmpgFileSize: param.hmpgFileSize,
        hmpgFileDataBase64: param.hmpgFileDataBase64,
        url: param.url,
        taxk: param.taxk,
        taxc: param.taxc,
        erms: param.erms,
        cvtn: param.cvtn,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })

    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Admin/Master/WIRKN/WIRKNUpdateApi.js